import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "wide-screen-msg-container"
};
const _hoisted_2 = {
  class: "wide-screen-msg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_icon, {
    icon: _ctx.icon,
    class: "wide-screen-msg-icon"
  }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.message), 1)]);
}